import React from "react";
import {
  Navbar,
  Homecontent,
  About,
  Roadmap,
  JoinCommunity,
  GetStarted,
  Footer,
  Team,
  Subscribe,
} from "./";

const Home = () => {
  return (
    <>
      <Navbar />
      <Homecontent />
      <About />
      <Roadmap />
      <Team />
      <GetStarted />
      <JoinCommunity />
      <Subscribe />
      <Footer />
    </>
  );
};

export default Home;
